module.exports = __webpack_public_path__ + "img/headBg.e9698200.png";